/**
 * Invoice Service
 * Handles invoice generation and retrieval
 */

const BASE_URL = process.env.NODE_ENV === 'production' 
  ? (process.env.REACT_APP_API_URL || '/api')
  : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api');

/**
 * Generate and download invoice PDF
 */
export const generateInvoice = async (orderId) => {
  try {
    const response = await fetch(`${BASE_URL}/invoice/orders/${orderId}/invoice`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('auth_token') || ''}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to generate invoice');
    }

    return response; // Return response to handle PDF download
  } catch (error) {
    console.error('Error generating invoice:', error);
    throw error;
  }
};

/**
 * Download invoice and trigger browser download
 */
export const downloadInvoice = async (orderId) => {
  try {
    const response = await generateInvoice(orderId);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Invoice_${orderId}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error downloading invoice:', error);
    throw error;
  }
};

const invoiceServiceExports = {
  generateInvoice,
  downloadInvoice,
};

export default invoiceServiceExports;
